import Cfgl from "@/views/cfgl/cfgl.vue";

export default {
    bggl:[
        // {
        //     name:"收房首页",url:"ggz",icon:"md-calendar",
        //     children:[]
        // },
        {
            name: "已收房源", url: "ggz", icon: "ios-home",
            url:"sfHouse",
            children: []
        },
        // {
        //     name: "收房确认", url: "ggz", icon: "ios-home",
        //     children: []
        // },
        // {
        //     name: "上传装修后照片", url: "ggz", icon: "ios-home",
        //     children: []
        // },
        {
            name: "待出租", url: "ggz", icon: "ios-home",
            url: "sfHouseRent",
            children: []
        },
        {
            name: "待提交合同", url: "ggz", icon: "ios-home",
            url: "submitContract",
            children: []
        },
        {
            name: "出房确认", url: "ggz", icon: "ios-home",
            url: "CfConfirm",
            children: []
        },
        // {
        //     name:"租房管理",icon:"ios-home",
        //     children:[
        //         {name:"收房-已收房源",url:"2_002_sf_ysfy",permissions:""},
        //         {name:"收房-收房确认",url:"2_003_sf_sfqr",permissions:""},
        //         {name:"上传装修后照片",url:"2_004_sczxhzp",permissions:""},
        //         {name:"出房-待出租",url:"2_007_cf_dcz",permissions:""},
        //     ]
        // },
      
    ],
    cfgl: [
        {
            name: "已出房源", url: "ggz", icon: "md-calendar",
            url: "cfHouse",
            children: []
        },
        // {
        //     name: "已收房源", url: "ggz", icon: "ios-home",
        //     url: "sfHouse",
        //     children: []
        // },
    ],
    moneyPlan:[
        {
            name: "收房付款计划", url: "ggz", icon: "md-calendar",
            url: "sfPlan",
            children: []
        },
        {
            name: "收房付款审核", url: "ggz", icon: "md-calendar",
            url: "sfPlanCheck",
            children: []
        },
        {
            name: "出房付款计划", url: "ggz", icon: "md-calendar",
            url: "cfPlan",
            children: []
        },
        {
            name: "出房付款审核", url: "ggz", icon: "md-calendar",
            url: "cfPlanCheck",
            children: []
        },
    ]
}